module.exports = __webpack_public_path__ + "static/media/02_thumbnail.0b0fd8b5.jpg";